import { combineReducers } from "redux";
import { proxiesReducer } from "modules/ProxyManager/services/Proxies/reducer";

export const proxyManagerReducer = combineReducers({
    entries: proxiesReducer,
});